function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/**
 * 通过 sportType 和 gradingSytem 2个值才能确定难度系统
 * 比如 sportType 是室内攀岩，gradingSystem 是 Rock_French，那就取 `INDOOR_CLIMB_GRADING_SYSTEM_DATA['Rock_French']`
 */

// 户外多段攀岩
var GRADING_SYSTEM_DATA = {
  // 优胜美地
  Rock_YDS: [{
    grade: 0,
    commonGrade: [1],
    gradeName: 'Jug the rope（上升器跟攀）',
    gradeNameI18n: 'H5047'
  }, {
    grade: 1,
    commonGrade: [2, 3, 4, 5],
    gradeName: 'Low 5th（简单攀爬）',
    gradeNameI18n: 'H5048'
  }, {
    grade: 2,
    commonGrade: [6],
    gradeName: '5.6'
  }, {
    grade: 3,
    commonGrade: [7],
    gradeName: '5.7'
  }, {
    grade: 4,
    commonGrade: [8],
    gradeName: '5.8'
  }, {
    grade: 5,
    commonGrade: [9],
    gradeName: '5.9'
  }, {
    grade: 6,
    commonGrade: [10],
    gradeName: '5.10a'
  }, {
    grade: 7,
    commonGrade: [11],
    gradeName: '5.10b'
  }, {
    grade: 8,
    commonGrade: [12],
    gradeName: '5.10c'
  }, {
    grade: 9,
    commonGrade: [13],
    gradeName: '5.10d'
  }, {
    grade: 10,
    commonGrade: [14],
    gradeName: '5.11a'
  }, {
    grade: 11,
    commonGrade: [15],
    gradeName: '5.11b'
  }, {
    grade: 12,
    commonGrade: [16],
    gradeName: '5.11c'
  }, {
    grade: 13,
    commonGrade: [17],
    gradeName: '5.11d'
  }, {
    grade: 14,
    commonGrade: [18],
    gradeName: '5.12a'
  }, {
    grade: 15,
    commonGrade: [19],
    gradeName: '5.12b'
  }, {
    grade: 16,
    commonGrade: [20],
    gradeName: '5.12c'
  }, {
    grade: 17,
    commonGrade: [21],
    gradeName: '5.12d'
  }, {
    grade: 18,
    commonGrade: [22],
    gradeName: '5.13a'
  }, {
    grade: 19,
    commonGrade: [23],
    gradeName: '5.13b'
  }, {
    grade: 20,
    commonGrade: [24],
    gradeName: '5.13c'
  }, {
    grade: 21,
    commonGrade: [25],
    gradeName: '5.13d'
  }, {
    grade: 22,
    commonGrade: [26],
    gradeName: '5.14a'
  }, {
    grade: 23,
    commonGrade: [27],
    gradeName: '5.14b'
  }, {
    grade: 24,
    commonGrade: [28],
    gradeName: '5.14c'
  }, {
    grade: 25,
    commonGrade: [29],
    gradeName: '5.14d'
  }, {
    grade: 26,
    commonGrade: [30],
    gradeName: '5.15a'
  }],
  // 法式
  Rock_French: [{
    grade: 0,
    commonGrade: [1],
    gradeName: 'Jug the rope（上升器跟攀）',
    gradeNameI18n: 'H5047'
  }, {
    grade: 1,
    commonGrade: [2],
    gradeName: 'Easy （简单攀爬）',
    gradeNameI18n: 'H5048'
  }, {
    grade: 2,
    commonGrade: [3],
    gradeName: '4a'
  }, {
    grade: 3,
    commonGrade: [4],
    gradeName: '4b'
  }, {
    grade: 4,
    commonGrade: [5],
    gradeName: '4c'
  }, {
    grade: 5,
    commonGrade: [6],
    gradeName: '5a'
  }, {
    grade: 6,
    commonGrade: [7],
    gradeName: '5b'
  }, {
    grade: 7,
    commonGrade: [8],
    gradeName: '5c'
  }, {
    grade: 8,
    commonGrade: [9],
    gradeName: '6a'
  }, {
    grade: 9,
    commonGrade: [10],
    gradeName: '6a+'
  }, {
    grade: 10,
    commonGrade: [11],
    gradeName: '6b'
  }, {
    grade: 11,
    commonGrade: [12],
    gradeName: '6b+'
  }, {
    grade: 12,
    commonGrade: [13],
    gradeName: '6c'
  }, {
    grade: 13,
    commonGrade: [14],
    gradeName: '6c+'
  }, {
    grade: 14,
    commonGrade: [15],
    gradeName: '7a'
  }, {
    grade: 15,
    commonGrade: [16],
    gradeName: '7a+'
  }, {
    grade: 16,
    commonGrade: [17],
    gradeName: '7b'
  }, {
    grade: 17,
    commonGrade: [18],
    gradeName: '7b+'
  }, {
    grade: 18,
    commonGrade: [19],
    gradeName: '7c'
  }, {
    grade: 19,
    commonGrade: [20],
    gradeName: '7c+'
  }, {
    grade: 20,
    commonGrade: [21],
    gradeName: '8a'
  }, {
    grade: 21,
    commonGrade: [22],
    gradeName: '8a+'
  }, {
    grade: 22,
    commonGrade: [23],
    gradeName: '8b'
  }, {
    grade: 23,
    commonGrade: [24],
    gradeName: '8b+'
  }, {
    grade: 24,
    commonGrade: [25],
    gradeName: '8c'
  }, {
    grade: 25,
    commonGrade: [26],
    gradeName: '8c+'
  }, {
    grade: 26,
    commonGrade: [27],
    gradeName: '9a'
  }, {
    grade: 27,
    commonGrade: [28],
    gradeName: '9a+'
  }, {
    grade: 28,
    commonGrade: [29],
    gradeName: '9b'
  }, {
    grade: 29,
    commonGrade: [30],
    gradeName: '9b+'
  }],
  // 器械攀岩
  Rock_Aid: [{
    grade: 0,
    commonGrade: [1],
    gradeName: 'Jug the rope（上升器跟攀）',
    gradeNameI18n: 'H5047'
  }, {
    grade: 1,
    commonGrade: [2, 3, 4, 5, 6, 7, 8, 9],
    gradeName: 'A1'
  }, {
    grade: 2,
    commonGrade: [10, 11, 12, 13, 14],
    gradeName: 'A2'
  }, {
    grade: 3,
    commonGrade: [15, 16, 17, 18, 19],
    gradeName: 'A3'
  }, {
    grade: 4,
    commonGrade: [20, 21, 22, 23, 24],
    gradeName: 'A4'
  }, {
    grade: 5,
    commonGrade: [25, 26, 27, 28, 29, 30],
    gradeName: 'A5'
  }],
  // 攀冰
  Ice_Grades: [{
    grade: 0,
    commonGrade: [1],
    gradeName: 'Jug the rope（上升器跟攀）',
    gradeNameI18n: 'H5047'
  }, {
    grade: 1,
    commonGrade: [2, 3, 4, 5],
    gradeName: 'WI1'
  }, {
    grade: 2,
    commonGrade: [6, 7, 8, 9],
    gradeName: 'WI2'
  }, {
    grade: 3,
    commonGrade: [10, 11, 12, 13],
    gradeName: 'WI3'
  }, {
    grade: 4,
    commonGrade: [14, 15, 16, 17],
    gradeName: 'WI4'
  }, {
    grade: 5,
    commonGrade: [18, 19, 20, 21],
    gradeName: 'WI5'
  }, {
    grade: 6,
    commonGrade: [22, 23, 24, 25],
    gradeName: 'WI6'
  }, {
    grade: 7,
    commonGrade: [26, 27, 28, 29, 30],
    gradeName: 'WI7'
  }],
  // 冰岩混合
  Mix_Grades: [{
    grade: 0,
    commonGrade: [1],
    gradeName: 'Jug the rope（上升器跟攀）',
    gradeNameI18n: 'H5047'
  }, {
    grade: 1,
    commonGrade: [2],
    gradeName: 'M1'
  }, {
    grade: 2,
    commonGrade: [3],
    gradeName: 'M2'
  }, {
    grade: 3,
    commonGrade: [4],
    gradeName: 'M3'
  }, {
    grade: 4,
    commonGrade: [5],
    gradeName: 'M4'
  }, {
    grade: 5,
    commonGrade: [6, 7],
    gradeName: 'M5'
  }, {
    grade: 6,
    commonGrade: [8, 9],
    gradeName: 'M6'
  }, {
    grade: 7,
    commonGrade: [10, 11],
    gradeName: 'M7'
  }, {
    grade: 8,
    commonGrade: [12, 13],
    gradeName: 'M8'
  }, {
    grade: 9,
    commonGrade: [14, 15],
    gradeName: 'M9'
  }, {
    grade: 10,
    commonGrade: [16, 17],
    gradeName: 'M10'
  }, {
    grade: 11,
    commonGrade: [18, 19],
    gradeName: 'M11'
  }, {
    grade: 12,
    commonGrade: [20, 21],
    gradeName: 'M12'
  }, {
    grade: 13,
    commonGrade: [22, 23],
    gradeName: 'M13'
  }, {
    grade: 14,
    commonGrade: [24, 25],
    gradeName: 'M14'
  }, {
    grade: 15,
    commonGrade: [26, 27],
    gradeName: 'M15'
  }, {
    grade: 16,
    commonGrade: [28, 29, 30],
    gradeName: 'M16'
  }],
  // 英式
  UK_TRAD: [{
    grade: 0,
    commonGrade: [1],
    gradeName: 'Jug the rope（上升器跟攀）',
    gradeNameI18n: 'H5047'
  }, {
    grade: 1,
    commonGrade: [2, 3],
    gradeName: 'VD'
  }, {
    grade: 2,
    commonGrade: [4],
    gradeName: 'S'
  }, {
    grade: 3,
    commonGrade: [5],
    gradeName: 'HS'
  }, {
    grade: 4,
    commonGrade: [6],
    gradeName: 'VS'
  }, {
    grade: 5,
    commonGrade: [7],
    gradeName: 'HVS'
  }, {
    grade: 6,
    commonGrade: [8, 9],
    gradeName: 'E1'
  }, {
    grade: 7,
    commonGrade: [10, 11],
    gradeName: 'E2'
  }, {
    grade: 8,
    commonGrade: [12, 13],
    gradeName: 'E3'
  }, {
    grade: 9,
    commonGrade: [14, 15],
    gradeName: 'E4'
  }, {
    grade: 10,
    commonGrade: [16, 17],
    gradeName: 'E5'
  }, {
    grade: 11,
    commonGrade: [18, 19],
    gradeName: 'E6'
  }, {
    grade: 12,
    commonGrade: [20, 21],
    gradeName: 'E7'
  }, {
    grade: 13,
    commonGrade: [22],
    gradeName: 'E8'
  }, {
    grade: 14,
    commonGrade: [23],
    gradeName: 'E9'
  }, {
    grade: 15,
    commonGrade: [24],
    gradeName: 'E10'
  }, {
    grade: 16,
    commonGrade: [25],
    gradeName: 'E11'
  }, {
    grade: 17,
    commonGrade: [26, 27, 28, 29, 30],
    gradeName: 'E12'
  }],
  // 国际登山与攀岩联盟
  UIAA: [{
    grade: 0,
    commonGrade: [1],
    gradeName: 'Jug the rope（上升器跟攀）',
    gradeNameI18n: 'H5047'
  }, {
    grade: 1,
    commonGrade: [2],
    gradeName: 'Easy （简单攀爬）',
    gradeNameI18n: 'H5048'
  }, {
    grade: 2,
    commonGrade: [3],
    gradeName: 'IV'
  }, {
    grade: 3,
    commonGrade: [4],
    gradeName: 'IV+'
  }, {
    grade: 4,
    commonGrade: [5],
    gradeName: 'V'
  }, {
    grade: 5,
    commonGrade: [6],
    gradeName: 'V+'
  }, {
    grade: 6,
    commonGrade: [7],
    gradeName: 'VI-'
  }, {
    grade: 7,
    commonGrade: [8],
    gradeName: 'VI'
  }, {
    grade: 8,
    commonGrade: [9],
    gradeName: 'VI+'
  }, {
    grade: 9,
    commonGrade: [10],
    gradeName: 'VII-'
  }, {
    grade: 10,
    commonGrade: [11],
    gradeName: 'VII'
  }, {
    grade: 11,
    commonGrade: [12],
    gradeName: 'VII+'
  }, {
    grade: 12,
    commonGrade: [13, 14],
    gradeName: 'VIII-'
  }, {
    grade: 13,
    commonGrade: [15],
    gradeName: 'VIII'
  }, {
    grade: 14,
    commonGrade: [16, 17],
    gradeName: 'VIII+'
  }, {
    grade: 15,
    commonGrade: [18],
    gradeName: 'IX-'
  }, {
    grade: 16,
    commonGrade: [19],
    gradeName: 'IX'
  }, {
    grade: 17,
    commonGrade: [20, 21],
    gradeName: 'IX+'
  }, {
    grade: 18,
    commonGrade: [22],
    gradeName: 'X-'
  }, {
    grade: 19,
    commonGrade: [23],
    gradeName: 'X'
  }, {
    grade: 20,
    commonGrade: [24, 25],
    gradeName: 'X+'
  }, {
    grade: 21,
    commonGrade: [26],
    gradeName: 'XI-'
  }, {
    grade: 22,
    commonGrade: [27],
    gradeName: 'XI'
  }, {
    grade: 23,
    commonGrade: [28],
    gradeName: 'XI+'
  }, {
    grade: 24,
    commonGrade: [29],
    gradeName: 'XII-'
  }, {
    grade: 25,
    commonGrade: [30],
    gradeName: 'XII'
  }],
  // 澳大利亚
  EWBANK: [{
    grade: 0,
    commonGrade: [1],
    gradeName: 'Jug the rope（上升器跟攀）',
    gradeNameI18n: 'H5047'
  }, {
    grade: 1,
    commonGrade: [2],
    gradeName: 'Easy （简单攀爬）',
    gradeNameI18n: 'H5048'
  }, {
    grade: 2,
    commonGrade: [3],
    gradeName: '12'
  }, {
    grade: 3,
    commonGrade: [4],
    gradeName: '13'
  }, {
    grade: 4,
    commonGrade: [5],
    gradeName: '14'
  }, {
    grade: 5,
    commonGrade: [6],
    gradeName: '15'
  }, {
    grade: 6,
    commonGrade: [7],
    gradeName: '16'
  }, {
    grade: 7,
    commonGrade: [8],
    gradeName: '17'
  }, {
    grade: 8,
    commonGrade: [9],
    gradeName: '18'
  }, {
    grade: 9,
    commonGrade: [10],
    gradeName: '19'
  }, {
    grade: 10,
    commonGrade: [11],
    gradeName: '20'
  }, {
    grade: 11,
    commonGrade: [12],
    gradeName: '21'
  }, {
    grade: 12,
    commonGrade: [13],
    gradeName: '22'
  }, {
    grade: 13,
    commonGrade: [14],
    gradeName: '23'
  }, {
    grade: 14,
    commonGrade: [15],
    gradeName: '24'
  }, {
    grade: 15,
    commonGrade: [16],
    gradeName: '25'
  }, {
    grade: 16,
    commonGrade: [17],
    gradeName: '26'
  }, {
    grade: 17,
    commonGrade: [18],
    gradeName: '27'
  }, {
    grade: 18,
    commonGrade: [19],
    gradeName: '28'
  }, {
    grade: 19,
    commonGrade: [20],
    gradeName: '29'
  }, {
    grade: 20,
    commonGrade: [21],
    gradeName: '30'
  }, {
    grade: 21,
    commonGrade: [22],
    gradeName: '31'
  }, {
    grade: 22,
    commonGrade: [23],
    gradeName: '32'
  }, {
    grade: 23,
    commonGrade: [24],
    gradeName: '33'
  }, {
    grade: 24,
    commonGrade: [25],
    gradeName: '34'
  }, {
    grade: 25,
    commonGrade: [26],
    gradeName: '35'
  }, {
    grade: 26,
    commonGrade: [27],
    gradeName: '36'
  }, {
    grade: 27,
    commonGrade: [28],
    gradeName: '37'
  }, {
    grade: 28,
    commonGrade: [29],
    gradeName: '38'
  }, {
    grade: 29,
    commonGrade: [30],
    gradeName: '39'
  }]
};

// 室内攀岩
var INDOOR_CLIMB_GRADING_SYSTEM_DATA = {
  // 优胜美地
  Rock_YDS: [{
    grade: 0,
    commonGrade: [1, 2, 3, 4],
    gradeName: '5.6'
  }, {
    grade: 1,
    commonGrade: [5],
    gradeName: '5.7'
  }, {
    grade: 2,
    commonGrade: [6],
    gradeName: '5.8'
  }, {
    grade: 3,
    commonGrade: [7],
    gradeName: '5.9'
  }, {
    grade: 4,
    commonGrade: [8],
    gradeName: '5.10a'
  }, {
    grade: 5,
    commonGrade: [9],
    gradeName: '5.10b'
  }, {
    grade: 6,
    commonGrade: [10],
    gradeName: '5.10c'
  }, {
    grade: 7,
    commonGrade: [11],
    gradeName: '5.10d'
  }, {
    grade: 8,
    commonGrade: [12],
    gradeName: '5.11a'
  }, {
    grade: 9,
    commonGrade: [13],
    gradeName: '5.11b'
  }, {
    grade: 10,
    commonGrade: [14],
    gradeName: '5.11c'
  }, {
    grade: 11,
    commonGrade: [15],
    gradeName: '5.11d'
  }, {
    grade: 12,
    commonGrade: [16],
    gradeName: '5.12a'
  }, {
    grade: 13,
    commonGrade: [17],
    gradeName: '5.12b'
  }, {
    grade: 14,
    commonGrade: [18],
    gradeName: '5.12c'
  }, {
    grade: 15,
    commonGrade: [19],
    gradeName: '5.12d'
  }, {
    grade: 16,
    commonGrade: [20],
    gradeName: '5.13a'
  }, {
    grade: 17,
    commonGrade: [21],
    gradeName: '5.13b'
  }, {
    grade: 18,
    commonGrade: [22],
    gradeName: '5.13c'
  }, {
    grade: 19,
    commonGrade: [23],
    gradeName: '5.13d'
  }, {
    grade: 20,
    commonGrade: [24],
    gradeName: '5.14a'
  }, {
    grade: 21,
    commonGrade: [25],
    gradeName: '5.14b'
  }, {
    grade: 22,
    commonGrade: [26],
    gradeName: '5.14c'
  }, {
    grade: 23,
    commonGrade: [27],
    gradeName: '5.14d'
  }, {
    grade: 24,
    commonGrade: [28],
    gradeName: '5.15a'
  }],
  // 法式
  Rock_French: [{
    grade: 0,
    commonGrade: [1],
    gradeName: '4a'
  }, {
    grade: 1,
    commonGrade: [2],
    gradeName: '4b'
  }, {
    grade: 2,
    commonGrade: [3],
    gradeName: '4c'
  }, {
    grade: 3,
    commonGrade: [4],
    gradeName: '5a'
  }, {
    grade: 4,
    commonGrade: [5],
    gradeName: '5b'
  }, {
    grade: 5,
    commonGrade: [6],
    gradeName: '5c'
  }, {
    grade: 6,
    commonGrade: [7],
    gradeName: '6a'
  }, {
    grade: 7,
    commonGrade: [8],
    gradeName: '6a+'
  }, {
    grade: 8,
    commonGrade: [9],
    gradeName: '6b'
  }, {
    grade: 9,
    commonGrade: [10],
    gradeName: '6b+'
  }, {
    grade: 10,
    commonGrade: [11],
    gradeName: '6c'
  }, {
    grade: 11,
    commonGrade: [12],
    gradeName: '6c+'
  }, {
    grade: 12,
    commonGrade: [13],
    gradeName: '7a'
  }, {
    grade: 13,
    commonGrade: [14],
    gradeName: '7a+'
  }, {
    grade: 14,
    commonGrade: [15],
    gradeName: '7b'
  }, {
    grade: 15,
    commonGrade: [16],
    gradeName: '7b+'
  }, {
    grade: 16,
    commonGrade: [17],
    gradeName: '7c'
  }, {
    grade: 17,
    commonGrade: [18],
    gradeName: '7c+'
  }, {
    grade: 18,
    commonGrade: [19],
    gradeName: '8a'
  }, {
    grade: 19,
    commonGrade: [20],
    gradeName: '8a+'
  }, {
    grade: 20,
    commonGrade: [21],
    gradeName: '8b'
  }, {
    grade: 21,
    commonGrade: [22],
    gradeName: '8b+'
  }, {
    grade: 22,
    commonGrade: [23],
    gradeName: '8c'
  }, {
    grade: 23,
    commonGrade: [24],
    gradeName: '8c+'
  }, {
    grade: 24,
    commonGrade: [25],
    gradeName: '9a'
  }, {
    grade: 25,
    commonGrade: [26],
    gradeName: '9a+'
  }, {
    grade: 26,
    commonGrade: [27],
    gradeName: '9b'
  }, {
    grade: 27,
    commonGrade: [28],
    gradeName: '9b+'
  }],
  // 国际登山与攀岩联盟
  UIAA: [{
    grade: 0,
    commonGrade: [1],
    gradeName: 'IV'
  }, {
    grade: 1,
    commonGrade: [2],
    gradeName: 'IV+'
  }, {
    grade: 2,
    commonGrade: [3],
    gradeName: 'V'
  }, {
    grade: 3,
    commonGrade: [4],
    gradeName: 'V+'
  }, {
    grade: 4,
    commonGrade: [5],
    gradeName: 'VI-'
  }, {
    grade: 5,
    commonGrade: [6],
    gradeName: 'VI'
  }, {
    grade: 6,
    commonGrade: [7],
    gradeName: 'VI+'
  }, {
    grade: 7,
    commonGrade: [8],
    gradeName: 'VII-'
  }, {
    grade: 8,
    commonGrade: [9],
    gradeName: 'VII'
  }, {
    grade: 9,
    commonGrade: [10],
    gradeName: 'VII+'
  }, {
    grade: 10,
    commonGrade: [11, 12],
    gradeName: 'VIII-'
  }, {
    grade: 11,
    commonGrade: [13],
    gradeName: 'VIII'
  }, {
    grade: 12,
    commonGrade: [14, 15],
    gradeName: 'VIII+'
  }, {
    grade: 13,
    commonGrade: [16],
    gradeName: 'IX-'
  }, {
    grade: 14,
    commonGrade: [17],
    gradeName: 'IX'
  }, {
    grade: 15,
    commonGrade: [18, 19],
    gradeName: 'IX+'
  }, {
    grade: 16,
    commonGrade: [20],
    gradeName: 'X-'
  }, {
    grade: 17,
    commonGrade: [21],
    gradeName: 'X'
  }, {
    grade: 18,
    commonGrade: [22, 23],
    gradeName: 'X+'
  }, {
    grade: 19,
    commonGrade: [24],
    gradeName: 'XI-'
  }, {
    grade: 20,
    commonGrade: [25],
    gradeName: 'XI'
  }, {
    grade: 21,
    commonGrade: [26],
    gradeName: 'XI+'
  }, {
    grade: 22,
    commonGrade: [27],
    gradeName: 'XII-'
  }, {
    grade: 23,
    commonGrade: [28],
    gradeName: 'XII'
  }],
  // 澳大利亚
  EWBANK: [{
    grade: 0,
    commonGrade: [1],
    gradeName: '12'
  }, {
    grade: 1,
    commonGrade: [2],
    gradeName: '13'
  }, {
    grade: 2,
    commonGrade: [3],
    gradeName: '14'
  }, {
    grade: 3,
    commonGrade: [4],
    gradeName: '15'
  }, {
    grade: 4,
    commonGrade: [5],
    gradeName: '16'
  }, {
    grade: 5,
    commonGrade: [6],
    gradeName: '17'
  }, {
    grade: 6,
    commonGrade: [7],
    gradeName: '18'
  }, {
    grade: 7,
    commonGrade: [8],
    gradeName: '19'
  }, {
    grade: 8,
    commonGrade: [9],
    gradeName: '20'
  }, {
    grade: 9,
    commonGrade: [10],
    gradeName: '21'
  }, {
    grade: 10,
    commonGrade: [11],
    gradeName: '22'
  }, {
    grade: 11,
    commonGrade: [12],
    gradeName: '23'
  }, {
    grade: 12,
    commonGrade: [13],
    gradeName: '24'
  }, {
    grade: 13,
    commonGrade: [14],
    gradeName: '25'
  }, {
    grade: 14,
    commonGrade: [15],
    gradeName: '26'
  }, {
    grade: 15,
    commonGrade: [16],
    gradeName: '27'
  }, {
    grade: 16,
    commonGrade: [17],
    gradeName: '28'
  }, {
    grade: 17,
    commonGrade: [18],
    gradeName: '29'
  }, {
    grade: 18,
    commonGrade: [19],
    gradeName: '30'
  }, {
    grade: 19,
    commonGrade: [20],
    gradeName: '31'
  }, {
    grade: 20,
    commonGrade: [21],
    gradeName: '32'
  }, {
    grade: 21,
    commonGrade: [22],
    gradeName: '33'
  }, {
    grade: 22,
    commonGrade: [23],
    gradeName: '34'
  }, {
    grade: 23,
    commonGrade: [24],
    gradeName: '35'
  }, {
    grade: 24,
    commonGrade: [25],
    gradeName: '36'
  }, {
    grade: 25,
    commonGrade: [26],
    gradeName: '37'
  }, {
    grade: 26,
    commonGrade: [27],
    gradeName: '38'
  }, {
    grade: 27,
    commonGrade: [28],
    gradeName: '39'
  }]
};

// 抱石攀岩
var BOULDERING_GRADING_SYSTEM_DATA = {
  // V等级抱石
  V_SCALE: [{
    grade: 0,
    commonGrade: [1],
    gradeName: 'V0'
  }, {
    grade: 1,
    commonGrade: [2],
    gradeName: 'V1'
  }, {
    grade: 2,
    commonGrade: [3],
    gradeName: 'V2'
  }, {
    grade: 3,
    commonGrade: [4, 5],
    gradeName: 'V3'
  }, {
    grade: 4,
    commonGrade: [6, 7],
    gradeName: 'V4'
  }, {
    grade: 5,
    commonGrade: [8, 9],
    gradeName: 'V5'
  }, {
    grade: 6,
    commonGrade: [10, 11],
    gradeName: 'V6'
  }, {
    grade: 7,
    commonGrade: [12],
    gradeName: 'V7'
  }, {
    grade: 8,
    commonGrade: [13],
    gradeName: 'V8'
  }, {
    grade: 9,
    commonGrade: [14],
    gradeName: 'V9'
  }, {
    grade: 10,
    commonGrade: [15],
    gradeName: 'V10'
  }, {
    grade: 11,
    commonGrade: [16],
    gradeName: 'V11'
  }, {
    grade: 12,
    commonGrade: [17],
    gradeName: 'V12'
  }, {
    grade: 13,
    commonGrade: [18],
    gradeName: 'V13'
  }, {
    grade: 14,
    commonGrade: [19],
    gradeName: 'V14'
  }, {
    grade: 15,
    commonGrade: [20],
    gradeName: 'V15'
  }, {
    grade: 16,
    commonGrade: [21],
    gradeName: 'V16'
  }, {
    grade: 17,
    commonGrade: [22],
    gradeName: 'V17'
  }],
  // 法式抱石
  FONT_SCALE: [{
    grade: 0,
    commonGrade: [1],
    gradeName: '4'
  }, {
    grade: 1,
    commonGrade: [2],
    gradeName: '5'
  }, {
    grade: 2,
    commonGrade: [3],
    gradeName: '5+'
  }, {
    grade: 3,
    commonGrade: [4],
    gradeName: '6A'
  }, {
    grade: 4,
    commonGrade: [5],
    gradeName: '6A+'
  }, {
    grade: 5,
    commonGrade: [6],
    gradeName: '6B'
  }, {
    grade: 6,
    commonGrade: [7],
    gradeName: '6B+'
  }, {
    grade: 7,
    commonGrade: [8],
    gradeName: '6C'
  }, {
    grade: 8,
    commonGrade: [9],
    gradeName: '6C+'
  }, {
    grade: 9,
    commonGrade: [10],
    gradeName: '7A'
  }, {
    grade: 10,
    commonGrade: [11],
    gradeName: '7A+'
  }, {
    grade: 11,
    commonGrade: [12],
    gradeName: '7B'
  }, {
    grade: 12,
    commonGrade: [13],
    gradeName: '7B+'
  }, {
    grade: 13,
    commonGrade: [14],
    gradeName: '7C'
  }, {
    grade: 14,
    commonGrade: [15],
    gradeName: '7C+'
  }, {
    grade: 15,
    commonGrade: [16],
    gradeName: '8A'
  }, {
    grade: 16,
    commonGrade: [17],
    gradeName: '8A+'
  }, {
    grade: 17,
    commonGrade: [18],
    gradeName: '8B'
  }, {
    grade: 18,
    commonGrade: [19],
    gradeName: '8B+'
  }, {
    grade: 19,
    commonGrade: [20],
    gradeName: '8C'
  }, {
    grade: 20,
    commonGrade: [21],
    gradeName: '8C+'
  }, {
    grade: 21,
    commonGrade: [22],
    gradeName: '9A'
  }]
};

// 部分场景只区分户外和室内
var INDOOR_CLIMB_BOULDERING_GRADING_SYSTEM_DATA = _objectSpread2(_objectSpread2({}, INDOOR_CLIMB_GRADING_SYSTEM_DATA), BOULDERING_GRADING_SYSTEM_DATA);

// 所有攀岩类型配置，包含户外、室内、抱石
// 参考 /docments/7COROS/协议文档/coros_data_protocol.md GRADING_SYSTEM_E
var GRADING_SYSTEM = [
// 1 优胜美地
{
  val: 1,
  name: 'Rock_YDS',
  title: '优胜美地',
  i18n: 'S4661'
},
// 2 法式
{
  val: 2,
  name: 'Rock_French',
  title: '法式',
  i18n: 'S4662'
},
// 3 器械攀岩
{
  val: 3,
  name: 'Rock_Aid',
  title: '器械攀岩'
},
// 4 攀冰
{
  val: 4,
  name: 'Ice_Grades',
  title: '攀冰'
},
// 5 冰岩混合
{
  val: 5,
  name: 'Mix_Grades',
  title: '冰岩混合'
},
// 6 英式
{
  val: 6,
  name: 'UK_TRAD',
  title: '英式'
},
// 7 V等级抱石
{
  val: 7,
  name: 'V_SCALE',
  title: 'V等级抱石',
  i18n: 'S4665'
},
// 8 法式抱石
{
  val: 8,
  name: 'FONT_SCALE',
  title: '法式抱石',
  i18n: 'S4666'
},
// 9 国际登山与攀岩联盟
{
  val: 9,
  name: 'UIAA',
  title: '国际登山与攀岩联盟',
  i18n: 'S4663'
},
// 10 澳大利亚
{
  val: 10,
  name: 'EWBANK',
  title: '澳大利亚',
  i18n: 'S4664'
}];
// 包含户外、室内、抱石
var GRADING_SYSTEM_VAL_DICT = GRADING_SYSTEM.reduce(function (acc, cur) {
  acc[cur.val] = cur;
  return acc;
}, {});

// 抱石
var BOULDERING_GRADING_SYSTEM = [
//V等级抱石
7,
//法式抱石
8];

// 先锋(室内攀岩)
var INDOOR_CLIMB_GRADING_SYSTEM = [
// 优胜美地
1,
// 法式
2,
//国际登山与攀岩联盟
9,
//澳大利亚
10];

// 完攀情况
// 0-红点 1-视攀 2-闪攀 3-尝试 4-未攀登 0xFF-未选择,显示-
var CLIMB_STYLE = [{
  i18n: 'H9081',
  color1: '#FF5F48',
  color2: '#C63C28',
  value: 0
}, {
  i18n: 'H9077',
  color1: '#40D4CF',
  color2: '#13828B',
  value: 1
}, {
  i18n: 'H9078',
  color1: '#2AC344',
  color2: '#0C802D',
  value: 2
}, {
  i18n: 'H9079',
  color1: '#FBE94A',
  color2: '#CFB323',
  value: 3
},
// 未攀登, 不绘制
// {
//   i18n: 'H9080',
//   color1: '#6A6D7C',
//   color2: '#2C3146',
//   value: 4,
//   nochart: true,
// },
// 未记录 unrecorded
{
  i18n: 'H9083',
  color1: '#6A6D7C',
  color2: '#2C3146',
  value: 255
}];
// 完攀情况字典
var CLIMB_STYLE_DICT = CLIMB_STYLE.reduce(function (acc, cur) {
  acc[cur.value] = cur;
  return acc;
}, {});

// 运动详情室内攀岩、抱石都用该图表名称
var INDOOR_CLIMB_BOULDERING_CHART_NAME = 'IndoorClimbGrade';

var i18nUtil = {
  t: function t() {}
};
var setuped = false;
function setUpT(_t) {
  if (!setuped && _t) {
    // console.log(`🔔 setup t`, _t);
    i18nUtil.t = _t;
    setuped = true;
  }
}

function isIndoorClimbTrainingSportType(sportType) {
  return sportType === 6;
}
function isBoulderingTrainingSportType(sportType) {
  return sportType === 7;
}
function isIndoorClimbOrBoulderingTrainingSportType(sportType) {
  return isIndoorClimbTrainingSportType(sportType) || isBoulderingTrainingSportType(sportType);
}
function isIndoorClimbOrBoulderingTrainingSportName(sportName) {
  return ['IndoorClimb', 'Bouldering'].includes(sportName);
}

// 获取难度系统的名称
function getGradingSystemName(val) {
  var _GRADING_SYSTEM_VAL_D;
  return ((_GRADING_SYSTEM_VAL_D = GRADING_SYSTEM_VAL_DICT[val]) === null || _GRADING_SYSTEM_VAL_D === void 0 ? void 0 : _GRADING_SYSTEM_VAL_D.name) || '';
}

// 获取难度系统的 i18n
function getGradingSystemI18nKey(val) {
  var _GRADING_SYSTEM_VAL_D2;
  return ((_GRADING_SYSTEM_VAL_D2 = GRADING_SYSTEM_VAL_DICT[val]) === null || _GRADING_SYSTEM_VAL_D2 === void 0 ? void 0 : _GRADING_SYSTEM_VAL_D2.i18n) || '';
}

// 使用难度系统type获取对应的难度系统信息
function getGradingSystem(isIndoorClimbOrBouldering, type) {
  var systemName = getGradingSystemName(type);
  if (!systemName) {
    return [];
  }
  var data = isIndoorClimbOrBouldering ? INDOOR_CLIMB_BOULDERING_GRADING_SYSTEM_DATA : GRADING_SYSTEM_DATA;
  return data[systemName] || [];
}

// 获取难度系统下的等级对应的公共等级信息
function getGradingGrade(isIndoorClimbOrBouldering, system, grade) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    returnMaxgradeWhenOver = _ref.returnMaxgradeWhenOver;
  var systemConfig = getGradingSystem(isIndoorClimbOrBouldering, system);
  if (!systemConfig || !systemConfig.length) {
    return null;
  }
  var maxGrade = systemConfig[systemConfig.length - 1];
  // 超过最大等级取最大
  if (grade > maxGrade.grade && returnMaxgradeWhenOver) {
    return maxGrade;
  }
  var result = systemConfig[grade];
  if (!result) {
    return null;
  }
  return result;
}

// 使用难度系统和公共难度序号获取对应的难度等级
function getGradingGradeByCommonGrade(isIndoorClimbOrBouldering, system, commonGrade) {
  var systemConfig = getGradingSystem(isIndoorClimbOrBouldering, system);
  if (!systemConfig) {
    return null;
  }
  var result = null;
  for (var n = 0, length = systemConfig.length; n < length; n++) {
    var grade = systemConfig[n];
    if (grade.commonGrade.includes(commonGrade)) {
      result = grade;
      break;
    }
  }
  return result;
}

// 运动详情图表，难度系数Y轴规则
function getGradingTickInfo(systemConfig, minGrade, maxGrade) {
  // d.难度系数Y轴规则
  // - 采用3段数值显示；均分为3等分；
  // - 最高柱为A；最低柱为 B;
  // - 当(A-B)<=3; 那么刻度为 [ B ,  B+1 ,  B+2 , B+3, ]，
  // 以上刻度无法完整取值则；刻度为 [ A-3 ,  A-2 ,  A-1 , A, ]
  // 【
  // 例如，A=5.14c, B=5.14b,
  // 用最小值向下取值只能取3个值，（5.14b,5.14c, 5.14d）
  // 那么就用最大值往上取值，（5.14a, 5.14b, 5.14c, 5.14d）
  // 】
  // - 当(A-B)>3; C=(A-B)/3, C向上取整为F; 那么刻度为 [ A-3F,  A-2F ,A-F, A, ]

  var systemLength = systemConfig.length;
  var result = [];
  var A = maxGrade.grade;
  var B = minGrade.grade;
  if (A - B <= 3) {
    result = [systemConfig[B], systemConfig[B + 1], systemConfig[B + 2], systemConfig[B + 3]];
    if (!systemConfig[B + 3]) {
      result = [systemConfig[A - 3], systemConfig[A - 2], systemConfig[A - 1], systemConfig[A]];
    }
  } else {
    var F = Math.ceil((A - B) / 3);
    if (F * 3 >= systemLength) {
      // 刻度不够
      result = [systemConfig[0], systemConfig[systemLength - 1 - 2 * F], systemConfig[systemLength - 1 - F], systemConfig[systemLength - 1]];
    } else {
      // 刻度足够使用
      result = [systemConfig[A - 3 * F], systemConfig[A - 2 * F], systemConfig[A - F], systemConfig[A]];
      if (!result[0]) {
        if (result[1].grade === 0) {
          result = [systemConfig[0], systemConfig[F], systemConfig[2 * F], systemConfig[3 * F]];
        } else {
          result = [systemConfig[0], systemConfig[A - 2 * F], systemConfig[A - F], systemConfig[A]];
        }
      }
    }
  }
  minGrade = result[0];
  maxGrade = result[3];
  var ticksInfo = {
    min: minGrade.commonGrade[minGrade.commonGrade.length - 1],
    max: maxGrade.commonGrade[maxGrade.commonGrade.length - 1],
    ticks: result.map(function (item) {
      return {
        value: item.commonGrade[item.commonGrade.length - 1],
        text: item.gradeNameI18n ? i18nUtil.t(item.gradeNameI18n) : item.gradeName
      };
    })
  };
  return ticksInfo;
}

// 训练课程难度系统下拉菜单
function getGradingSytemOptions(sportType) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$addNotSetOption = _ref2.addNotSetOption,
    addNotSetOption = _ref2$addNotSetOption === void 0 ? true : _ref2$addNotSetOption,
    _ref2$addCustomOption = _ref2.addCustomOption,
    addCustomOption = _ref2$addCustomOption === void 0 ? false : _ref2$addCustomOption;
  var data = sportType === 6 ? INDOOR_CLIMB_GRADING_SYSTEM : BOULDERING_GRADING_SYSTEM;
  var options = data.map(function (val) {
    return {
      value: val,
      label: i18nUtil.t(GRADING_SYSTEM_VAL_DICT[val].i18n)
    };
  });
  if (addNotSetOption) {
    options.push({
      value: 0,
      label: i18nUtil.t('S4313')
    });
  }
  if (addCustomOption) {
    options.push({
      value: 'custom',
      label: i18nUtil.t('T5064')
    });
  }
  return options;
}
var onsightGradeOffsetI18nConf = ['S4681',
// 视攀-8
'S4680', 'S4679', 'S4678', 'S4677', 'S4676', 'S4675', 'S4674', 'S4673',
// 视攀
'S4672', 'S4671', 'S4670', 'S4669' // 视攀+4
];

function getOnSightI18nKey(i) {
  var offset = i - 32;
  var zeroIndex = 8; // 视攀所在index
  return i18nUtil.t(onsightGradeOffsetI18nConf[zeroIndex + offset]);
}
// 训练课程难度等级选择菜单
function getGradeLevelOptions(sportType, gradingSystem) {
  var gradingSystemName = GRADING_SYSTEM_VAL_DICT[gradingSystem].name;
  var systemData = sportType === 6 ? INDOOR_CLIMB_GRADING_SYSTEM_DATA : BOULDERING_GRADING_SYSTEM_DATA;
  var data = systemData[gradingSystemName];
  // console.log(`getGradeLevelOptions`, Object.keys(systemData), gradingSystemName, data);
  // 切换 sportType 的时候，sportType 和 gradingSystem 没有同步改变
  if (!data) return [];
  var relativeLevelOptions = Array.from({
    length: 13
  }).map(function (_, i) {
    var label = onsightGradeOffsetI18nConf[i];
    if (i < 9) {
      return {
        value: "1-".concat(32 - (8 - i)),
        label: i18nUtil.t(label)
      };
    } else {
      return {
        value: "1-".concat(32 + (i - 8)),
        label: i18nUtil.t(label)
      };
    }
  });
  return [{
    value: '1',
    label: i18nUtil.t('S4659'),
    children: relativeLevelOptions
  }, {
    value: '2',
    label: i18nUtil.t('S4660'),
    children: data.map(function (item) {
      return {
        value: '2-' + item.grade,
        label: item.gradeName
      };
    })
  }];
}

// 训练课程显示难度等级
function getDisplayHardLevelValue(_ref3) {
  var globalGradeSystem = _ref3.globalGradeSystem,
    exerciseGradeSystem = _ref3.exerciseGradeSystem,
    climbConfig = _ref3.climbConfig,
    sportType = _ref3.sportType,
    val = _ref3.val;
  if (!isIndoorClimbOrBoulderingTrainingSportType(sportType)) return;
  var _val$split$map = val.split('-').map(function (str) {
      return parseInt(str, 10);
    }),
    _val$split$map2 = _slicedToArray(_val$split$map, 2),
    levelType = _val$split$map2[0],
    level = _val$split$map2[1];
  // 曼诗说选择了难度等级，这里不显示
  if (levelType === 2) return '';
  var userConf = climbConfig.find(function (item) {
    return item.sportType === sportType;
  });

  // toSystem 即最终使用的难度系统
  var toSystem = globalGradeSystem && 'custom' !== globalGradeSystem ? globalGradeSystem : userConf.gradingSystem;
  if (['custom', undefined].includes(globalGradeSystem) && exerciseGradeSystem) {
    toSystem = exerciseGradeSystem;
  }
  var userGradeIndex = userConf.gradeIndex;
  // levelType=1 并且难度系统跟用户设置不一样的时候，这里的值要进行换算
  // console.log(`toSystem`, toSystem, userConf.gradingSystem);
  if (toSystem !== userConf.gradingSystem) {
    userGradeIndex = hardLevelConvert(userConf.gradingSystem, toSystem, userGradeIndex);
  }

  // console.log(`userGradeIndex`, userGradeIndex, 'level', level);
  var convertedLevel = userGradeIndex + (level - 32);
  if (convertedLevel < 0) convertedLevel = 0;
  var result = getGradingGrade(true, toSystem, convertedLevel, {
    returnMaxgradeWhenOver: true
  });
  return result.gradeName;
}

// 不同难度系统间的难度等级换算
function hardLevelConvert(fromSystem, toSystem, level) {
  // 拿到 commonGrade 来换算
  var oldInfo = getGradingGrade(true, fromSystem, level);
  var newInfo = getGradingGradeByCommonGrade(true, toSystem, oldInfo.commonGrade[oldInfo.commonGrade.length - 1]);
  // console.log(`newInfo`, newInfo);
  return newInfo.grade;
}
function test_t(key) {
  return i18nUtil.t(key);
}

var climb = /*#__PURE__*/Object.freeze({
  __proto__: null,
  GRADING_SYSTEM_DATA: GRADING_SYSTEM_DATA,
  INDOOR_CLIMB_GRADING_SYSTEM_DATA: INDOOR_CLIMB_GRADING_SYSTEM_DATA,
  BOULDERING_GRADING_SYSTEM_DATA: BOULDERING_GRADING_SYSTEM_DATA,
  INDOOR_CLIMB_BOULDERING_GRADING_SYSTEM_DATA: INDOOR_CLIMB_BOULDERING_GRADING_SYSTEM_DATA,
  GRADING_SYSTEM: GRADING_SYSTEM,
  GRADING_SYSTEM_VAL_DICT: GRADING_SYSTEM_VAL_DICT,
  BOULDERING_GRADING_SYSTEM: BOULDERING_GRADING_SYSTEM,
  INDOOR_CLIMB_GRADING_SYSTEM: INDOOR_CLIMB_GRADING_SYSTEM,
  CLIMB_STYLE: CLIMB_STYLE,
  CLIMB_STYLE_DICT: CLIMB_STYLE_DICT,
  INDOOR_CLIMB_BOULDERING_CHART_NAME: INDOOR_CLIMB_BOULDERING_CHART_NAME,
  isIndoorClimbTrainingSportType: isIndoorClimbTrainingSportType,
  isBoulderingTrainingSportType: isBoulderingTrainingSportType,
  isIndoorClimbOrBoulderingTrainingSportType: isIndoorClimbOrBoulderingTrainingSportType,
  isIndoorClimbOrBoulderingTrainingSportName: isIndoorClimbOrBoulderingTrainingSportName,
  getGradingSystemName: getGradingSystemName,
  getGradingSystemI18nKey: getGradingSystemI18nKey,
  getGradingSystem: getGradingSystem,
  getGradingGrade: getGradingGrade,
  getGradingGradeByCommonGrade: getGradingGradeByCommonGrade,
  getGradingTickInfo: getGradingTickInfo,
  getGradingSytemOptions: getGradingSytemOptions,
  getOnSightI18nKey: getOnSightI18nKey,
  getGradeLevelOptions: getGradeLevelOptions,
  getDisplayHardLevelValue: getDisplayHardLevelValue,
  hardLevelConvert: hardLevelConvert,
  test_t: test_t
});

var sport = {
  climb: climb
};

export { setUpT, sport };
//# sourceMappingURL=index.esm.js.map
